(function FlagAsTravelInsiderForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'FlagAsTravelInsider',
	};

	$(document).ready(function documentReady() {
		Adzuki.Form.registerForm(form);
	});

	form.load = function load($form)
	{
		$("#flagastravelinsider-travel_insider").on('change', function changeCheck() {
			var $self = $(this);

			// alert($self.prop("checked"));

			if ($self.prop("checked")) {
				$('#tip_code_row').removeClass('hidden');
			} else {
				$('#tip_code_row').addClass('hidden');
				$('#flagastravelinsider-amex_tip_code_id').val('');
			}
		});
	};

}(jQuery, window.Adzuki || {}));
